import React from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import DoorShapes from '../../wizard/styled/DoorShapes';

export default class DoorSvg extends React.Component {
  render() {
    const {
      url,
      width,
      background,
      border,
    } = this.props;
    return (
      <DoorShapes style={{ width: `${width}px` }} background={background} border={border}>
        <SVG src={url} />
      </DoorShapes>
    );
  }
}

DoorSvg.propTypes = {
  url: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  background: PropTypes.string.isRequired,
  border: PropTypes.string.isRequired,
};
